var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgManualentry = function SvgManualentry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32.000000pt",
    height: "32.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1419 4255 c-56 -18 -113 -77 -128 -132 -6 -22 -11 -136 -11 -265 l0 -228 -223 0 c-170 0 -236 -4 -274 -15 -176 -52 -195 -314 -29 -391 49 -23 60 -24 289 -24 l237 0 0 -234 c0 -150 4 -245 12 -267 19 -57 49 -90 102 -115 91 -42 185 -27 252 40 56 56 64 99 64 361 l0 215 228 0 c135 0 243 5 267 11 61 17 120 82 134 148 17 80 -6 169 -55 212 -58 51 -76 54 -331 57 l-241 4 -4 241 c-3 225 -5 245 -24 282 -12 22 -30 47 -40 56 -57 50 -150 68 -225 44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2699 2974 c-105 -32 -166 -162 -127 -275 19 -57 49 -90 102 -115 l51 -24 773 0 772 0 0 -425 0 -425 -1710 0 -1710 0 0 243 c0 236 -1 245 -23 288 -15 29 -40 54 -71 74 -41 25 -58 29 -116 29 -58 0 -75 -4 -116 -29 -31 -20 -56 -45 -71 -75 -24 -45 -24 -46 -21 -345 l3 -300 33 -68 c58 -119 169 -208 293 -236 61 -14 3537 -14 3598 0 123 28 235 119 293 236 l33 68 3 514 c3 558 2 571 -54 667 -31 53 -119 136 -173 164 -96 48 -123 50 -946 49 -637 0 -778 -3 -816 -15z"
  }))));
};

export default SvgManualentry;